import { h } from "preact"
import { BaseComponentType } from "../../types/common"

type CardHeaderProps = {
   className?: string
} & BaseComponentType

export default function CardHeader({ children, className = "" }: CardHeaderProps) {
   return (
      <div
         className={`card-header d-flex flex-wrap justify-content-between align-items-center gap-2 ${className}`}
      >
         {children}
      </div>
   )
}
